// Company and contact information configuration
export const COMPANY_INFO = {
  name: "MenuAnalyzer.AI",
  tagline: "Healthy eating made simple",
  address: {
    street: "5457 Twin Knolls Rd, Ste 300 #1437",
    city: "Columbia",
    state: "MD",
    zipCode: "21045",
    country: "United States"
  },
  contact: {
    phone: "(443) 319-1034",
    email: "support@menuanalyzer.ai",
  }
};

// Helper function to get formatted address
export const getFormattedAddress = () => {
  const { address } = COMPANY_INFO;
  return {
    line1: address.street,
    line2: `${address.city}, ${address.state} ${address.zipCode}`,
    line3: address.country
  };
};

// Helper function to get full address as array
export const getAddressLines = () => {
  const { address } = COMPANY_INFO;
  return [
    COMPANY_INFO.name,
    address.street,
    `${address.city}, ${address.state} ${address.zipCode}`,
    address.country
  ];
};
